import ThirdPartyTracking from '@thebeansgroup/third_party_tracking'

import { getOneTrustCookieConsentContexts } from '@helpers/cookie_consents'
import { getConversionApiSnowplowContexts } from '@helpers/third_party_tracking'

export const thirdPartyTrackingPageView = (pageType, dedupeId, contentId) => {
  switch (pageType) {
    default:
      ThirdPartyTracking.pageView(dedupeId, contentId)
  }
}

export const getCustomContexts = (
  customContexts,
  pixelDedupeUid,
  email,
  contentId
) => {
  const conversionApiContexts = getConversionApiSnowplowContexts(
    pixelDedupeUid,
    email,
    contentId
  )
  if (!Array.isArray(customContexts)) return [...conversionApiContexts]

  return [
    ...customContexts,
    ...conversionApiContexts,
    ...getOneTrustCookieConsentContexts()
  ]
}
